export const FORGOT_PASSWORD_REQUEST = 'FORGOT_PASSWORD_REQUEST';

export const USER_LOGOUT_REQUEST = 'USER_LOGOUT_REQUEST';

export const UNREAD_MESSAGE_COUNT_REQUEST = 'UNREAD_MESSAGE_COUNT_REQUEST';
export const UNREAD_MESSAGE_COUNT_SUCCESS = 'UNREAD_MESSAGE_COUNT_SUCCESS';
export const UNREAD_MESSAGE_COUNT_START = 'UNREAD_MESSAGE_COUNT_START';
export const UNREAD_MESSAGE_COUNT_STOP = 'UNREAD_MESSAGE_COUNT_STOP';

export const USER_LOGIN_FORM_REQUEST = 'USER_LOGIN_FORM_REQUEST';
export const USER_LOGIN_FORM_SUCCESS = 'USER_LOGIN_FORM_SUCCESS';
export const USER_LOGIN_FORM_FAILURE = 'USER_LOGIN_FORM_FAILURE';

export const USER_GET_REQUEST = 'USER_GET_REQUEST';
export const USER_GET_SUCCESS = 'USER_GET_SUCCESS';
export const USER_GET_FAILURE = 'USER_GET_FAILURE';

export const CREATE_USER_REQUEST = 'CREATE_USER_REQUEST';
export const CREATE_USER_SUCCESS = 'CREATE_USER_SUCCESS';
export const CREATE_USER_FAILURE = 'CREATE_USER_FAILURE';

export const GET_USER_ACCOUNT = 'GET_USER_ACCOUNT';
export const GET_USER_ACCOUNT_SUCCESS = 'GET_USER_ACCOUNT_SUCCESS';

export const CHANGE_PASSWORD_REQUEST = 'CHANGE_PASSWORD_REQUEST';

export const CHANGE_SETTINGS_PASSWORD_REQUEST = 'CHANGE_SETTINGS_PASSWORD_REQUEST';
export const CHANGE_SETTINGS_PASSWORD_SUCCESS = 'CHANGE_SETTINGS_PASSWORD_SUCCESS';
export const CHANGE_SETTINGS_PASSWORD_FAILURE = 'CHANGE_SETTINGS_PASSWORD_FAILURE';
export const RESET_SETTINGS_PASSWORD = 'RESET_SETTINGS_PASSWORD';

export const VERIFY_CHANGE_PASSWORD_REQUEST = 'VERIFY_CHANGE_PASSWORD_REQUEST';

export const INVITE_USER_REQUEST = 'INVITE_USER_REQUEST';
export const INVITE_USER_SUCCESS = 'INVITE_USER_SUCCESS';
export const INVITE_USER_FAILURE = 'INVITE_USER_FAILURE';
export const RESET_INVITE_USER_REQUEST = 'RESET_INVITE_USER_REQUEST';
